import { TableBody, Typography } from '@mui/material';

import { StyledCard, StyledTable } from './styles';
import { ChangeHistoryLine } from './components';
import type { ChangeHistoryProps } from './types';

export function ChangeHistory({ changeHistory }: Readonly<ChangeHistoryProps>) {
  if (!changeHistory || changeHistory.length === 0) {
    return null;
  }

  return (
    <StyledCard>
      <Typography variant="subtitle1">Histórico de alterações</Typography>
      <StyledTable>
        <TableBody>
          {changeHistory.map((changeHistoryLine, index) => {
            const key = String(index);
            return (
              <ChangeHistoryLine
                key={key}
                changeHistoryLine={changeHistoryLine}
              />
            );
          })}
        </TableBody>
      </StyledTable>
    </StyledCard>
  );
}
